import { apiUrls } from '@http/api-urls'
import { httpService } from '@http/service'
import { HttpOptions } from '@http/service/options'
// import * as Sentry from '@sentry/node'
import { NextPageFC } from '@shared/models/next-fc'
import { GetServerSideProps } from 'next'

import {
	SignDocumentsApiModel,
	SignScreenType,
	SignUIConfigApiModel,
	SignUserApiModel,
} from '../screens/sign/api-types'
import { PageLayoutBrokerSign } from '../screens/sign/layouts/page-layout-broker-sign'
import { PageLayoutShotApplication } from '../screens/sign/layouts/page-layout-short-application'
import { PageLayoutShotApplicationProps } from '../screens/sign/layouts/page-layout-short-application/model'
import { BrokerAnyDocsScreen } from '../screens/sign/screens/broker-any-docs'
import { BrokerConsentScreen } from '../screens/sign/screens/broker-consent'
import { SignClientLkApplicationScreen } from '../screens/sign/screens/client-lk-application'
import { SignShortApplicationScreen } from '../screens/sign/screens/short-application'
import { BrokerSignScreenBaseProps } from '../screens/sign/shared/broker/types'

const Sign: NextPageFC<BrokerSignScreenBaseProps, PageLayoutShotApplicationProps> = (props) => {
	const { preset } = props.uiConfig

	if (preset === SignScreenType.BROKER_CONSENT) {
		return BrokerConsentScreen(props)
	}

	if (preset === SignScreenType.BROKER_ANY_DOCS) {
		return BrokerAnyDocsScreen(props)
	}

	if (preset === SignScreenType.SHORT_APPLICATION) {
		return SignShortApplicationScreen()
	}

	if (preset === SignScreenType.CLIENT_LK_APPLICATION) {
		return SignClientLkApplicationScreen()
	}

	return null
}

Sign.layout = ({ pageProps, children, ...layoutProps }) => {
	if (pageProps.uiConfig.preset === SignScreenType.SHORT_APPLICATION) {
		return PageLayoutShotApplication({
			children,
			...layoutProps,
			hasError: pageProps.hasError,
		})
	}

	return PageLayoutBrokerSign({
		uiConfig: pageProps.uiConfig,
		hasError: pageProps.hasError,
		children,
	})
}

Sign.headProps = ({ uiConfig: { preset } }) => {
	return {
		[SignScreenType.SHORT_APPLICATION]: {
			title: 'Подтвердите заявку',
			description:
				'Согласие с обработкой персональных данных на сайте Credit.Club. Перечень основных моментов.',
		},
		[SignScreenType.BROKER_ANY_DOCS]: {
			title: 'Подпишите документы',
			description: '',
		},
		[SignScreenType.BROKER_CONSENT]: {
			title: 'Подтвердите регистрацию',
			description: '',
		},
	}[preset]
}

export const getServerSideProps: GetServerSideProps<Partial<BrokerSignScreenBaseProps>> = async (
	ctx
) => {
	const opts = new HttpOptions().setHeader('cookie', ctx.req.headers.cookie!)
	try {
		const uiConfig = await httpService.get<SignUIConfigApiModel>(apiUrls.esia.uiConfig(), opts)
		const user = await httpService.get<SignUserApiModel>(apiUrls.getUser(), opts)
		if (uiConfig.preset === SignScreenType.SHORT_APPLICATION) {
			return {
				props: {
					user,
					uiConfig,
					documents: [],
				},
			}
		}

		const documents = await httpService.get<SignDocumentsApiModel>(apiUrls.esia.documents(), opts)
		return {
			props: {
				user,
				uiConfig,
				documents,
			},
		}
	} catch (err) {
		// Sentry.captureException(err)

		return {
			props: {
				hasError: true,
				user: {
					phone: '',
				},
				uiConfig: {
					preset: SignScreenType.SHORT_APPLICATION,
					params: {
						logoUri: '',
						brokerOrgName: '',
						brokerOrgPhone: '',
					},
				},
				documents: [],
			},
		}
	}
}

export default Sign
